export default {
  data() {
    return {
      searchSchema: [
        {
          label: '评分时间',
          itemName: 'times',
          type: 'rangePicker',
          allowClear: true,
          format: 'YYYY-MM-DD',
          // startDate
        },
        {
          label: '客户名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
        status: '',
        endDate: '',
        startDate: '',
        times: '',
      },
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '客户名称',
          dataIndex: 'tname',
          width: 120,
        },
        {
          title: '查询企业名称',
          dataIndex: 'cname',
          width: 100,
        },
        {
          title: '评分时间',
          dataIndex: 'date',
          width: 120,
        },
        {
          title: '基础分',
          dataIndex: 'base',
          width: 120,
        },
        {
          title: '提升分',
          dataIndex: 'addition',
          width: 120,
        },
        {
          title: '总分',
          dataIndex: 'total',
          width: 120,
        },
        {
          title: '综合等级',
          dataIndex: 'grade',
          width: 120,
        },
        {
          fixed: 'right',
          title: '操作',
          dataIndex: 'status',
          width: 180,
          scopedSlots: { customRender: 'status' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
